import { combineReducers } from '@reduxjs/toolkit'

import { reducer as ordersList } from './list'

export default combineReducers({ ordersList })
